export default {
  login: '/login',
  code: '/login/code',
  sms: '/login/sms',
  guest: '/login/guest',
} as const;
